"use client";
import { useAuthQuery } from "@stadium/services/apollo-client";

import { fetchWorkspaces } from "@stadium/hooks/graphql/queries/company-space/fetch-workspaces";
import { useFlags } from "@stadium/services/launch-darkly";
import { workspaceLaunchFlag } from "@stadium/services/launch-darkly/constants";

const emptyArr = [];
const emptyObj = {};

type FetchWorkpaceHookType = {
  type?: string;
  skip?: boolean;
};

const useFetchWorkspaces = ({ type = "", skip = false } = emptyObj as FetchWorkpaceHookType) => {
  const { [workspaceLaunchFlag]: workspaceLaunchFlagEnabled } = useFlags();
  const { data, loading, called, refetch } = useAuthQuery(fetchWorkspaces, {
    variables: {
      type,
    },
    skip: skip || !workspaceLaunchFlagEnabled,
  });

  const workspaces = data?.workspaces || emptyArr;

  return {
    workspaces,
    loading,
    called,
    refetch,
  };
};

export default useFetchWorkspaces;
